import { render } from "./BottomBar.vue?vue&type=template&id=4f870550&scoped=true"
const script = {}

import "./BottomBar.vue?vue&type=style&index=0&id=4f870550&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f870550"

export default script